/* Free gifts in the cart.
   1) Every order with a Matcha Routine product gets a free Mini Balm (automatic Shopify discount does the pricing).
   2) Visitors who came via /discount/MATCHASECRET additionally get the Matcha To Go Bag (priced via the code).
   This script only adds/removes the gift lines; Shopify discounts make them free.
   Note: Shopify deletes the discount_code cookie once the checkout has been opened, so a To Go Bag that was
   already added to this cart is kept even when the cookie is gone. */
(function () {
  var CODE = 'MATCHASECRET';
  var PROP = '_gift';
  var OLD_PROP = '_collab_gift';
  var TRIGGER_HANDLES = [
    'matcha-almond-shampoo',
    'matcha-coconut-oil',
    'matcha-vanilla-shea-balm',
    'matcha-routine-powder',
    'matcha-routine-gua-sha',
    'matcha-routine-scalp-brush',
    'the-whole-day'
  ];
  var MINI_BALM = 50588044132686;
  var TO_GO_BAG = 61334427959630;
  var busy = false;

  function codeActive() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    if (!m) return false;
    try { return decodeURIComponent(m[1]).toUpperCase() === CODE; } catch (e) { return false; }
  }

  function jsonHeaders() { return { 'Content-Type': 'application/json', 'Accept': 'application/json' }; }

  function isGiftLine(i) {
    return !!(i.properties && (i.properties[PROP] || i.properties[OLD_PROP]));
  }

  async function refreshTheme() {
    try {
      if (window.theme && theme.cart) {
        await theme.cart.fetchTotals();
        await theme.cart.updateAllHtml();
      }
    } catch (e) {}
  }

  function readAdded(key) {
    try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; }
  }
  function writeAdded(key, arr) {
    try { if (arr.length) localStorage.setItem(key, JSON.stringify(arr)); else localStorage.removeItem(key); } catch (e) {}
  }

  async function sync() {
    if (busy) return;
    busy = true;
    try {
      var res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return;
      var cart = await res.json();
      var items = cart.items || [];
      var key = 'ms_gifts_added2_' + cart.token;
      var hasTrigger = items.some(function (i) { return TRIGGER_HANDLES.indexOf(i.handle) > -1; });
      var active = codeActive();
      var already = readAdded(key);
      var bagKept = already.indexOf(TO_GO_BAG) > -1;

      var wanted = [];
      if (hasTrigger) wanted.push(MINI_BALM);
      if (hasTrigger && (active || bagKept)) wanted.push(TO_GO_BAG);

      var changed = false;

      // 1) remove gift lines that are no longer wanted (trigger product or code gone)
      var removals = {};
      var removeAny = false;
      items.forEach(function (i) {
        if (isGiftLine(i) && wanted.indexOf(i.variant_id) === -1) {
          removals[i.key] = 0; removeAny = true;
        }
      });
      if (removeAny) {
        var rm = await fetch('/cart/update.js', {
          method: 'POST', headers: jsonHeaders(), body: JSON.stringify({ updates: removals })
        });
        if (rm.ok) {
          changed = true;
          already = already.filter(function (id) { return wanted.indexOf(id) > -1; });
          writeAdded(key, already);
        }
      }

      // 2) add wanted gifts once per cart (if the customer removes one, it stays removed)
      var toAdd = wanted.filter(function (id) {
        if (already.indexOf(id) > -1) return false;
        if (id === TO_GO_BAG && !active) return false; // never add the bag without the code
        return !items.some(function (i) { return i.variant_id === id && !removals.hasOwnProperty(i.key); });
      });
      if (toAdd.length) {
        var add = await fetch('/cart/add.js', {
          method: 'POST',
          headers: jsonHeaders(),
          body: JSON.stringify({
            items: toAdd.map(function (id) {
              var p = {}; p[PROP] = id === MINI_BALM ? 'free-mini-balm' : 'matchasecret';
              return { id: id, quantity: 1, properties: p };
            })
          })
        });
        if (add.ok) {
          writeAdded(key, already.concat(toAdd));
          changed = true;
        }
      }

      if (changed) await refreshTheme();
    } catch (e) {
    } finally {
      busy = false;
    }
  }

  function later() { setTimeout(sync, 400); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();

  window.addEventListener('theme:cart:productAdded', later);
  window.addEventListener('theme:cart:updated', later);
  window.addEventListener('pageshow', later);
})();
